import "../../components/welcomeScreen/welcomeWizard.scss";

import PropTypes from "prop-types";
import React from "react";

import ModalGroup from "../../components/modal/ModalGroup";
import WelcomeWizardTypeButtonLayout from "../../components/welcomeScreen/WelcomeWizardTypeButtonLayout";
import syncApplications from "../../constants/syncApplications";
import userAgent from "../../utils/userAgent";

const macApplications = [
  {
    id: syncApplications.SCRIVENER,
    label: "Scrivener",
    icon: "scrivener",
    iconColor: "iconSoften"
  },
  {
    id: syncApplications.ULYSSES,
    label: "Ulysses",
    icon: "ulysses",
    iconColor: "iconSoften"
  }
];

const windowsApplications = [
  {
    id: syncApplications.SCRIVENER,
    label: "Scrivener",
    icon: "scrivener",
    iconColor: "iconSoften"
  }
];

const getApplications = () => {
  if (userAgent.isMacApp()) {
    return macApplications;
  }
  return windowsApplications;
};

const SyncApplicationPage = props => {
  return (
    <ModalGroup key="content">
      <WelcomeWizardTypeButtonLayout types={getApplications()} onButtonClick={props.onAppClick} />
    </ModalGroup>
  );
};

SyncApplicationPage.propTypes = {
  onAppClick: PropTypes.func.isRequired
};

export default SyncApplicationPage;
